/**
 * State of range inputs for table date cell
 */
export enum RangeInputValueState {
    /**
     * Indicates that input started at this specific date/cell
     */
    START = 'START',

    /**
     * Indicates that input ended at this specific date/cell
     */
    END = 'END',

    /**
     * Indicates that it is a cell where input is currently active but there is no lines after this cell
     * It is NOW cell
     */
    END_ACTIVE = 'END_ACTIVE',

    /**
     * Indicates that input was active at this specific date/cell
     */
    ACTIVE = 'ACTIVE',
}
